import React, { useState, useEffect } from "react";
import { withBreakpoints } from "react-breakpoints";

import Landing from "../containers/landing/Landing";
import Mission from "../containers/mission/Mission";
import Projects from "../containers/projects/Projects";
import Partners from "../containers/partners/Partners";
import Contact from "../containers/contact/Contact";
import ContactFAB from "../containers/contact/ContactFAB";

const LandingPage = (props) => {
  const { breakpoints, currentBreakpoint } = props;
  const isBreakpoint = breakpoints[currentBreakpoint] < breakpoints.desktop;

  const [yOffset, setYOffset] = useState(Math.floor(window.pageYOffset));

  const handleScroll = () => {
    setYOffset(Math.floor(window.pageYOffset));
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  return (
    <div>
      <ContactFAB isBreakpoint={isBreakpoint} />
      <Landing yOffset={yOffset} sectionIndex={1} isBreakpoint={isBreakpoint} />
      <Mission yOffset={yOffset} sectionIndex={1} isBreakpoint={isBreakpoint} />
      <Projects
        yOffset={yOffset}
        sectionIndex={2}
        isBreakpoint={isBreakpoint}
      />
      <Partners
        yOffset={yOffset}
        sectionIndex={3}
        isBreakpoint={isBreakpoint}
      />
      <Contact yOffset={yOffset} sectionIndex={4} isBreakpoint={isBreakpoint} />
    </div>
  );
};

export default withBreakpoints(LandingPage);
